export const checkIfStringExist = (val) => {
  return val ? val : '-'
}
